import React, { useMemo } from 'react';
import { Alert } from '@mui/material';
import { useFilters } from '@/contexts/FilterContext';
import { useProducts } from '@/contexts/ProductsContext';
import { ProductOptionLabel } from '@/components/ProductOptionLabel';

/** Indica qual produto (seletor do topo) as abas Termos / Trial / Credenciais estão editando. */
export const ProductScopeBar: React.FC = () => {
  const { productId } = useFilters();
  const { productsById } = useProducts();

  const product = useMemo(() => {
    if (!productId) return null;
    const p = productsById.get(productId);
    return { productId, displayName: p?.displayName };
  }, [productsById, productId]);

  if (!product) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      Configuração do produto:{' '}
      <strong>
        <ProductOptionLabel displayName={product.displayName} productId={product.productId} />
      </strong>
      . Troque o produto no filtro da barra superior — cada aba abaixo é independente por produto.
    </Alert>
  );
};
